import React from 'react';
import { useAuth } from '../../hooks/useAuth';
import { useBooking } from '../../hooks/useBooking';
import Layout from '../../components/layout/Layout';
import RegisterModal from '../../components/auth/RegisterModal';
import { PAGES } from '../../utils/constants';

const RegisterPage = () => {
  const { closeRegisterModal, openLoginModal } = useAuth();
  const { setCurrentPage } = useBooking();

  const handleClose = () => {
    setCurrentPage(PAGES.HOME);
  };

  const handleSwitchToLogin = () => {
    closeRegisterModal();
    openLoginModal();
    setCurrentPage(PAGES.LOGIN);
  };

  return (
    <Layout>
      <RegisterModal 
        onClose={handleClose}
        onSwitchToLogin={handleSwitchToLogin}
      />
    </Layout>
  );
};

export default RegisterPage;
